<template>
  <div class="date-icon">
    <i class="icon icon-date"></i>
  </div>
</template>

<script>
import moment from 'moment'
import daterangepicker from 'daterangepicker'
$.noConflict()
import $ from 'jquery'
export default {
  props: {
    dateFrom: String,
    dateTo: String,
  },
  mounted() {
    const self = this
    // setup daterange element
    this.setupDateRange()
    const dateButton = $('.date-icon')
    dateButton.on('apply.daterangepicker', function(ev, picker) {
      console.log('apply.daterangepicker')
      console.log('PICKER DATE', picker)
      console.log('PICKER DATE', picker.startDate, moment('19800101'))
      if (picker.startDate.isSame('19800101') && picker.endDate.isSame('19800101')) {
        // day of year selected, launch popup
        console.log('PICKER DOY')
        self.$emit('dayOfYearSelected')
      } else if (picker.startDate.isSame('19800102') && picker.endDate.isSame('19800102')) {
        // GPS week selected
        console.log('PICKER GPSWEEK')
        self.$emit('GPSWeekSelected')
      } else {
        // any other date selected, launch daterangechanged
        self.$emit('dateRangeChanged', picker)
        console.log('date picked', [moment().startOf('day'), moment().endOf('day')])
      }
    })
    dateButton.on('show.daterangepicker', function(ev, picker) {
      console.log('show.daterangepicker')
      console.log(self.dateFrom)
      console.log('start', picker.startDate.format('YYYY-MM-DD HH:mm'))
      console.log(self.dateTo)
      console.log('end', picker.endDate.format('YYYY-MM-DD HH:mm'))
      // this.dateFrom
      //   ? picker.setStartDate(this.dateFrom)
      //   : picker.setStartDate(
      //       moment()
      //         .startOf('day')
      //         .subtract(1, 'days'),
      //     )
      // this.dateTo ? picker.setEndDate(this.dateTo) : picker.setEndDate(moment().endOf('day'))
      self.$emit('showPicker')
    })
    dateButton.on('hide.daterangepicker', function(ev, picker) {
      self.$emit('hidePicker')
      console.log('hide.daterangepicker')
    })
  },
  methods: {
    setupDateRange() {
      console.log('run_setupdaterange')
      $('.date-icon').daterangepicker({
        linkedCalendars: false,
        showDropdowns: true,
        minDate: '1980-01-01',
        maxDate: moment().format('YYYY-MM-DD HH:mm'),
        startDate: moment()
          .subtract(1, 'days')
          .format('YYYY-MM-DD HH:mm'),
        endDate: moment().format('YYYY-MM-DD HH:mm'),
        timePicker: true,
        timePicker24Hour: true,
        ranges: {
          // Today: [moment().startOf('day'), moment().endOf('day')],
          // Yesterday: [
          //   moment()
          //     .subtract(1, 'days')
          //     .startOf('day'),
          //   moment()
          //     .subtract(1, 'days')
          //     .endOf('day'),
          // ],
          // 'Last 7 Days': [
          //   moment()
          //     .subtract(6, 'days')
          //     .startOf('day'),
          //   moment().endOf('day'),
          // ],
          // 'Last 30 Days': [
          //   moment()
          //     .subtract(29, 'days')
          //     .startOf('day'),
          //   moment().endOf('day'),
          // ],
          // 'This Month': [moment().startOf('month'), moment().endOf('month')],
          // 'Last Month': [
          //   moment()
          //     .subtract(1, 'month')
          //     .startOf('month'),
          //   moment()
          //     .subtract(1, 'month')
          //     .endOf('month'),
          // ],
          // 'This Year': [moment().startOf('year'), moment().endOf('year')],
          'GPS Week': [moment('19800102'), moment('19800102')],
          'Day of Year': [moment('19800101'), moment('19800101')],
        },
        locale: {
          format: 'YYYY-MM-DD HH:mm',
          separator: ' - ',
          applyLabel: 'Apply',
          cancelLabel: 'Cancel',
          fromLabel: 'From',
          toLabel: 'To',
          customRangeLabel: 'Calendar Day',
          weekLabel: 'W',
          daysOfWeek: ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'],
          monthNames: [
            'January',
            'February',
            'March',
            'April',
            'May',
            'June',
            'July',
            'August',
            'September',
            'October',
            'November',
            'December',
          ],
          firstDay: 1,
        },
        buttonClasses: 'btn btn-sm',
        applyButtonClasses: 'btn-outline-primary',
        cancelClass: 'btn-default',
      })
    },
  },
  watch: {
    dateFrom: function() {
      const dateButton = $('.date-icon')
      console.log('DATES datefrom changed', this.dateFrom)
      this.dateFrom
        ? dateButton.data('daterangepicker').setStartDate(this.dateFrom)
        : dateButton.data('daterangepicker').setStartDate(
            moment()
              .startOf('day')
              .subtract(1, 'days')
          )
    },
    dateTo: function() {
      const dateButton = $('.date-icon')
      console.log('DATES datetochanged', this.dateTo)
      this.dateTo
        ? dateButton.data('daterangepicker').setEndDate(this.dateTo)
        : dateButton.data('daterangepicker').setEndDate(moment().endOf('day'))
    },
  },
}
</script>

<style lang="scss" scoped>
// Estilos del icono de fecha
.date-icon {
  border: 1px solid #ced4da;
  display: flex;
  align-items: center;
  height: 38px;
}
</style>
